import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import { InjectedAppScrollerProps, withAppScroller } from 'src/_context/AppScroller';
import stylesheet, { directions } from 'src/constants/stylesheet';

export type PartProps =
    {
        containerProps?: React.HTMLAttributes<HTMLElement>,
        contentProps?: React.HTMLAttributes<HTMLElement>,
        loading: boolean;
        title?: string;
        url: string;
    };

const styles = {
    container: {
        // position: 'absolute',
        // right: 0,
        // left: 0,
        // top: 0,
        backgroundColor: 'white'
    },

    content: {
        opacity: 0,
        transform: 'translate3d(0, 50px, 0)',
        transition: 'all 0.7s ease-out'
    },
    loaded: {
        '& $content': {
            opacity: 1,
            transform: 'translate3d(0, 0, 0)',
        }
    },
    title: {
        ...stylesheet.Title,
        textAlign: 'center'
    },
    titlePadding: {
        ...stylesheet.PaddingGutter(1, directions.sides | directions.bottom)
    }
};

type Props =
    PartProps &
    StyledComponentProps<keyof typeof styles> &
    InjectedAppScrollerProps;

type State = {
};

class Part extends React.Component<Props, State> {
    private container: React.RefObject<HTMLElement> = React.createRef<HTMLElement>();
    constructor(props: Props) {
        super(props);

        this.state = {
        };
    }
    componentDidMount() {
        const { appScrollerCtx, url, title } = this.props;
        const { current } = this.container;
        if (current) {
            appScrollerCtx.registerPart(current, url, title);
        }
    }
    componentDidUpdate() {
        // ok 
    }
    componentWillUnmount() {
        const { appScrollerCtx, url } = this.props;
        appScrollerCtx.unRegisterPart(url);
    }

    render() {
        const {
            children,
            classes,
            loading,
            containerProps,
            contentProps,
            title
        } = this.props;

        return (
            <article
                ref={this.container}
                {...containerProps}
                className={
                    classNames(
                        classes!.container,
                        !loading && classes!.loaded,
                        containerProps && containerProps.className
                    )
                }
            >
                <div
                    {...contentProps}
                    className={
                        classNames(
                            classes!.content,
                            contentProps && contentProps.className
                        )
                    }

                >
                    {title && <h2 className={classNames(classes!.title, classes!.titlePadding)}>{title}</h2>}
                    {children}
                </div>
            </article>);
    }
}

export default withStyles(styles)(withAppScroller(Part));


// WEBPACK FOOTER //
// ./src/components/Part.tsx